import React from "react";
import { Link } from "react-router-dom";
import "../css/terms.scss";

const termsSections = [
  {
    title: "Online store terms",
    body: [
      "You must be at least the age of majority where you live, or have the consent required to allow minor dependents to use this site. You may not use the products or service for an unlawful or unauthorized purpose.",
      "Transmitting destructive code, including viruses or worms, is prohibited. A breach of these terms may result in immediate termination of service.",
    ],
  },
  {
    title: "General conditions",
    body: [
      "ioomparade may refuse service to anyone for any lawful reason at any time. Content you submit may be adapted to technical requirements. Card details are entered only on the payment provider's secure page.",
      "You may not reproduce, duplicate, copy, sell, resell, or exploit the service without express written permission.",
    ],
  },
  {
    title: "Accuracy, completeness, and timeliness of information",
    body: [
      "Site material is provided for general information and may not always be complete, current, or accurate. Historical information is supplied for reference only.",
      "ioomparade may change site content at any time but is not obligated to update it. You are responsible for monitoring changes that matter to you.",
    ],
  },
  {
    title: "Modifications to the service and prices",
    body: [
      "Product prices may change without notice. ioomparade may modify, suspend, or discontinue all or part of the service without notice and is not liable for those changes where the law permits.",
    ],
  },
  {
    title: "Products or services",
    body: [
      "Some products and services are available only online and may have limited quantities. Returns and exchanges are governed by the Returns Policy.",
      "ioomparade works to display product colors and images accurately, but cannot guarantee how every screen will render them. Sales, quantities, and availability may be limited by person, region, or jurisdiction.",
    ],
  },
  {
    title: "Billing and account information",
    body: [
      "ioomparade may refuse, limit, or cancel an order, including orders that appear to come from the same account, payment method, address, dealer, reseller, or distributor. If an order is changed or canceled, reasonable efforts may be made to notify you using the details supplied at checkout.",
      "You agree to provide current, complete, and accurate purchase and account information and to keep it updated so transactions and communications can be completed.",
    ],
  },
  {
    title: "Optional tools",
    body: [
      "The store may offer access to third-party tools it does not monitor or control. Those tools are provided as available and without endorsement or warranties; your use of them is at your discretion and subject to the relevant provider's terms.",
    ],
  },
  {
    title: "Third-party links",
    body: [
      "The service may contain third-party services or links. ioomparade is not responsible for examining those sites or for their content, accuracy, policies, products, or transactions.",
      "Review a third party's policies before completing a transaction and direct concerns about its products or services to that third party.",
    ],
  },
  {
    title: "Comments, feedback, and submissions",
    body: [
      "Unless prohibited by law, feedback and other submissions you send may be used to improve our products and service. ioomparade is not required to keep unsolicited submissions confidential or respond to them.",
      "Your comments must not violate another person's rights, contain unlawful or abusive material, impersonate someone else, mislead as to their origin, or introduce malicious code. You remain responsible for what you submit.",
    ],
  },
  {
    title: "Personal information",
    body: [
      "Personal information submitted through the store is handled under the Privacy Policy.",
    ],
  },
  {
    title: "Errors, inaccuracies, and omissions",
    body: [
      "Product descriptions, prices, promotions, shipping charges, transit times, and availability may occasionally contain errors or omissions. ioomparade may correct them, update information, or cancel an affected order at any time, including after an order is submitted.",
      "There is no obligation to amend or clarify information except where the law requires it.",
    ],
  },
  {
    title: "Prohibited uses",
    body: [
      "You may not use the site or its content for unlawful activity; to solicit unlawful acts; to violate applicable laws or intellectual-property rights; to harass, discriminate, mislead, spam, scrape, or collect personal information; to upload malicious code; or to interfere with security features.",
      "ioomparade may terminate access for a prohibited use.",
    ],
  },
  {
    title: "Disclaimer of warranties and limitation of liability",
    body: [
      "ioomparade does not promise that the service will always be uninterrupted, timely, secure, or error-free, or that results will always be accurate or reliable. The service and products are provided as available, except where an express statement or applicable law says otherwise.",
      "To the fullest extent allowed by law, ioomparade and its related parties are not liable for indirect, incidental, punitive, special, or consequential loss arising from use of the service or products. Where a jurisdiction does not allow a particular exclusion, liability is limited to the maximum lawful extent.",
    ],
  },
  {
    title: "Indemnification",
    body: [
      "Where permitted by applicable law, you are responsible for third-party claims and reasonable losses caused by your unlawful use of the service, your material breach of these terms, or your infringement of another person's rights. This clause does not apply to loss caused by ioomparade or to responsibility that cannot lawfully be transferred to a consumer.",
    ],
  },
  {
    title: "Ownership and intellectual property",
    body: [
      "Unless another owner or licence is identified, the ioomparade name and original site-specific text, graphics, photographs, and page arrangement are owned by or licensed to ioomparade. Access to the store does not transfer ownership or grant a commercial content licence.",
      "Third-party names and marks remain the property of their respective owners. Review the Intellectual Property & Takedown Policy to request permission or report a rights concern.",
    ],
  },
  {
    title: "Consumer guarantees",
    body: [
      "Nothing in these terms excludes, restricts, or modifies a guarantee, remedy, cooling-off right, or other consumer protection that applicable law says cannot be excluded. If a clause conflicts with a mandatory right, that right prevails to the extent of the conflict.",
    ],
  },
  {
    title: "Events beyond reasonable control",
    body: [
      "ioomparade is not responsible for delay caused by events outside reasonable control, such as severe weather, carrier or network disruption, customs action, labour interruption, public emergency, government restriction, or failure of essential third-party infrastructure. We will take reasonable steps to reduce the effect and perform outstanding obligations when practicable.",
    ],
  },
  {
    title: "Severability",
    body: [
      "If a provision is found unlawful, void, or unenforceable, it will be enforced to the greatest lawful extent and severed only as necessary. The remaining provisions continue in effect.",
    ],
  },
  {
    title: "Termination",
    body: [
      "Obligations and liabilities incurred before termination survive. You may stop using the service at any time. ioomparade may terminate access if it believes you have failed to comply with these terms; amounts owed up to the termination date remain due.",
    ],
  },
  {
    title: "Entire agreement",
    body: [
      "These terms and the policies posted on the site form the entire agreement governing the service and replace earlier agreements or communications. A failure to enforce a provision is not a waiver, and ambiguities are not automatically interpreted against the drafting party.",
    ],
  },
  {
    title: "Governing law",
    body: [
      "These terms and separate service agreements are governed by the applicable laws of the Hong Kong Special Administrative Region, without depriving a consumer of mandatory protection or a forum that applicable law makes available in the consumer's home jurisdiction.",
    ],
  },
  {
    title: "Changes to these terms",
    body: [
      "The latest version is available on this page. ioomparade may update these terms by posting changes to the website. Continuing to use the site after a change constitutes acceptance of the revised terms.",
    ],
  },
  {
    title: "Contact information",
    body: [
      "Questions about these Terms of Service should be sent to globe@ioomparade.online.",
    ],
  },
];

function Terms() {
  return (
    <main className="ink-info-page ink-info-page--terms">
      <div className="ink-info-page__inner">
        <header className="ink-info-page__header">
          <p className="ink-info-page__eyebrow">Please read carefully</p>
          <h1>Terms of Service</h1>
          <p className="ink-info-page__lead">
            These terms govern access to ioomparade&apos;s website, information,
            products, and services. By visiting the site or making a purchase,
            you agree to them and to the policies referenced here.
          </p>
          <p className="policy-updated">
            Effective and last updated: <time dateTime="2026-10-16">October 16, 2026</time>
          </p>
        </header>

        <section className="terms-overview" aria-labelledby="terms-overview-title">
          <p className="ink-info-page__kicker">Overview</p>
          <h2 id="terms-overview-title">Using the ioomparade store</h2>
          <p>
            ioomparade operates this website. The words “we,” “us,” and “our”
            refer to ioomparade. If you
            do not agree to all of these terms, you should not access the site or
            use its services.
          </p>
          <div className="terms-overview__links">
            <Link to="/privacy">Privacy policy</Link>
            <Link to="/returns">Returns policy</Link>
            <Link to="/policies">All store policies</Link>
          </div>
        </section>

        <nav className="terms-index" aria-label="Terms of Service sections">
          <p>On this page</p>
          <ol>
            {termsSections.map((section, index) => (
              <li key={section.title}>
                <a href={`#terms-section-${index + 1}`}>{section.title}</a>
              </li>
            ))}
          </ol>
        </nav>

        <section className="terms-sections" aria-label="Terms of Service details">
          {termsSections.map((section, index) => (
            <details
              className="terms-section"
              id={`terms-section-${index + 1}`}
              key={section.title}
              open={index === 0}
            >
              <summary>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <h2>{section.title}</h2>
                <span className="terms-section__icon" aria-hidden="true" />
              </summary>
              <div className="terms-section__body">
                {section.body.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
                {section.title === "Personal information" && (
                  <p>
                    Read the <Link to="/privacy">Privacy Policy</Link>.
                  </p>
                )}
                {section.title === "Ownership and intellectual property" && (
                  <p>
                    Read the <Link to="/policies/intellectual-property">Intellectual Property &amp; Takedown Policy</Link>.
                  </p>
                )}
                {section.title === "Contact information" && (
                  <p>
                    <a href="mailto:globe@ioomparade.online">Email globe@ioomparade.online</a>
                  </p>
                )}
              </div>
            </details>
          ))}
        </section>
      </div>
    </main>
  );
}

export default Terms;
